import axios from 'axios';
import { authHeader } from './authservice/auth-header';

 const API_URL = process.env.VUE_APP_BASE_API_URL_OSINT;
 const BASE_API = process.env.VUE_APP_BASE_API_URL;
 const TWIX_API = process.env.VUE_APP_TWIX_API;

// const ELASTIC_API = process.env.VUE_APP_ELASTIC_API;

class TwintService {
    search(data) {
        // Menggunakan API baru TWIX_API dengan query parameter
        const searchQuery = data.query || '';
        return axios.get(`${TWIX_API}search/users?name=${encodeURIComponent(searchQuery)}`);
    }
    getUser(data) {
        return axios.post(API_URL+'twitter/get-user', data);
    }
    getTrend(data){
        return axios.post(API_URL+'twitter/trends', data);
    }

    // BARU V2
    getTimelinev2Twint(data){
        // Menggunakan API baru TWIX_API dengan format: users/{username}/timeline
        const username = data.username || data.nama || data.id || '';
        return axios.get(`${TWIX_API}users/${username}/timeline`);
    }
    // end

    getTimelineTwint(data){
        return axios.post(API_URL+'twitter/get-timeline', data);
    }
    getTimelineElastic(ip, username){
        return axios.get(ip+'osint_twitter_timeline/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createTimelineElastic(ip, username, data){
        return axios.put(ip+'osint_twitter_timeline/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }
    createTimelinev2Elastic(ip, username, data){
        return axios.put(ip+'osint_twitter_timeline/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }
    createTimelinev2backend(data) {
        return axios.post(BASE_API + 'socmed/tw/timeline', data, { headers: authHeader() });
    }
    GetEngagement(data1, data2) {
        return axios.post(BASE_API + 'socmed/tw/engagement', {data1, data2}, { headers: authHeader() });
    }
    
    getMentionsTwint(data){
        return axios.post(API_URL+'twitter/get-mentions', data);
    }
    getMentionsElastic(ip, username){
        return axios.get(ip+'osint_twitter_topmention/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createMentionsElastic(ip, username, data){
        return axios.put(ip+'osint_twitter_topmention/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }
    
   
    getTopFollowing(data){
        // Menggunakan API baru TWIX_API dengan format: users/{username}/following
        const username = data.nama || data.id || data.username || '';
        return axios.get(`${TWIX_API}users/${username}/following`);
    }
    getTopFollowers(data){
        // Menggunakan API baru TWIX_API dengan format: users/{username}/followers
        const username = data.nama || data.id || data.username || '';
        return axios.get(`${TWIX_API}users/${username}/followers`);
    }
    getFollowElastic(ip, username){
        return axios.get(ip+'osint_twitter_follow/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createFollowElastic(ip, username, data){
        return axios.put(ip+'osint_twitter_follow/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }


    getHeatMap(data) {
        // Menggunakan API baru TWIX_API dengan format: users/{username}/heatmap
        const username = data.nama || data.id || data.username || '';
        return axios.get(`${TWIX_API}users/${username}/heatmap`);
    }
    getHeatMapElastic(ip, username){
        return axios.get(ip+'osint_twitter_heatmap/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createHeatMapElastic(ip, username, data){
        return axios.put(ip+'osint_twitter_heatmap/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }
    
    
    SentimentAnalys(data){
        // Menggunakan API baru TWIX_API dengan format: users/{username}/sentiment
        const username = data.nama || data.id || data.username || '';
        return axios.get(`${TWIX_API}users/${username}/sentiment`);
    }
    SentimentAnalysElastic(ip, username){
        return axios.get(ip+'osint_twitter_sentiment/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createUserSentimentElastic(ip, username, data){
        return axios.put(ip+'osint_twitter_sentiment/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }


    getSource(data){
        // Menggunakan API baru TWIX_API dengan format: users/{username}/sources
        const username = data.nama || data.id || data.username || '';
        return axios.get(`${TWIX_API}users/${username}/sources`);
    }
    getSourceElastic(ip, username){
        return axios.get(ip+'osint_twitter_source/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createUserSourceElastic(ip, username, data){
        return axios.put(ip+'osint_twitter_source/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }


    getWordCloud(data) {
        // Menggunakan API baru TWIX_API dengan format: users/{username}/wordcloud
        const username = data.nama || data.id || data.username || '';
        return axios.get(`${TWIX_API}users/${username}/wordcloud`);
    }
    getWordCloudElastic(ip, username){
        return axios.get(ip+'osint_twitter_wordcloud/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createUserWordCloudElastic(ip, username, data){
        return axios.put(ip+'osint_twitter_wordcloud/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }


    getHastagsCloud(data) {
        return axios.post(API_URL+'twitter/hastags', data);
    }
    getHastagsElastic(ip, username){
        return axios.get(ip+'osint_twitter_tophastag/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createUserHastagsElastic(ip, username, data){
        return axios.put(ip+'osint_twitter_tophastag/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    } 
}

export default new TwintService();
